import Table from "@tiptap/extension-table"
import TableCell from "@tiptap/extension-table-cell"
import TableHeader from "@tiptap/extension-table-header"
import TableRow from "@tiptap/extension-table-row"
import Youtube from "@tiptap/extension-youtube"

import {
	getDefaultExtensions,
	VideoExtension,
} from "@productlane/lib/src/browser"
import { IframeExtension } from "@productlane/lib/src/tiptap/extensions/iframe-extension"

import type { Extensions } from "@tiptap/core"
import { CustomImageExtension } from "./extensions/custom-image-extension"

// The schema must hold everything Linear markdown can carry: a node the editor
// cannot represent is silently dropped, and the next save replaces the whole
// Linear description without it.
export function getIssueDescriptionSchemaExtensions(): Extensions {
	return [
		...getDefaultExtensions({ image: false }),
		Table.configure({ resizable: false }),
		TableRow,
		TableHeader,
		TableCell,
		VideoExtension,
		Youtube.configure({ nocookie: true }),
		IframeExtension,
		CustomImageExtension,
	]
}
